import { Typography } from '@mui/material'
import { GRAY_COLORS } from 'asterX-UI'
import { useRoutes } from 'lib/hooks/index'
import { useModalbar } from 'lib/modules/Modalbar'
import { useTranslation } from 'react-i18next'

/**
 * @function useResErrors
 *  hook
 *  @example const {standardCheck} = useResErrors()
 *  @return {Object}  {standardCheck()}
 */
const useResErrors = () => {
  const { unAuthByStatus, goPrevPage } = useRoutes()
  const { callModalbar } = useModalbar()
  const { t } = useTranslation()

  /**
   * @function standardCheck
   * checkOnError
   * @param {object|array} res
   * @param {function} onSuccess
   * @param {object} options
   * @param {string} options.textErr
   * @param {function} options.onFail
   * @param {function|null} options.onErrCustom
   *  @example standardCheck(res,onSuccess(),{ textErr: 'error'})
   */
  const standardCheck = (
    res,
    onSuccess,
    options = {
      textErr: ' ',
      onFail: () => {},
      onErrCustom: null
    }
  ) => {
    const { textErr, onFail, onErrCustom } = options
    if ([200, 201].includes(res?.status) && !res.hasOwnProperty('err')) {
      try {
        onSuccess && onSuccess(res)
      } catch (e) {
        console.error(e)
        callModalbar(t('errors.inFunction', { path: 'lib/hooks/useResErrors.js' }), e.toString(), {
          variant: 'error',
          onCloseAction: goPrevPage
        })
      }
    } else {
      try {
        const status = res && res.hasOwnProperty('status') ? res.status : ''
        unAuthByStatus(status)

        const msg = res && res.hasOwnProperty('msg') ? res.msg.message : 'Что-то пошло не так'
        if (!onErrCustom) {
          callModalbar(
            `${textErr || res?.err} ${textErr && status ? status : ''}`,
            <div style={{ display: 'flex', flexDirection: 'column' }}>
              <Typography
                variant="body1"
                sx={{
                  background: GRAY_COLORS[300],
                  borderRadius: 1,
                  overflowY: 'auto',
                  color: GRAY_COLORS[800],
                  maxHeight: 320,
                  overflowWrap: 'break-word',
                  padding: 1
                }}
              >
                {msg || 'Что-то пошло не так'}
              </Typography>
              {res?.path && (
                <Typography variant="subtitle1" color="textSecondary">
                  {`Path: ${res?.path || ''}`}
                </Typography>
              )}
            </div>,
            {
              variant: 'error',
              onCloseAction: onFail
            }
          )
        } else {
          onErrCustom && typeof onErrCustom === 'function' && onErrCustom(status)
        }
      } catch (e) {
        console.error(e)
        callModalbar(t('errors.inFunction', { path: 'lib/hooks/useResErrors.js' }), e.toString(), {
          variant: 'error',
          onCloseAction: goPrevPage
        })
      }
    }
  }

  return {
    standardCheck
  }
}

export default useResErrors
